export default {
	persons: {
		access: 'Zugang',
		contactInfo: 'Kontaktdaten',
		noFurtherEmails: 'Keine weiteren E-Mail-Adressen hinterlegt.',
		personalDoc: 'Personenbezogene Dokumente',
		accounts: 'Konten',
		roles: {
			label: 'Sichtbar für Funktion / Personenfunktion',
		},
	},
}
